import { render, staticRenderFns } from "./ItemTwo.vue?vue&type=template&id=5438e996&scoped=true"
import script from "./ItemTwo.vue?vue&type=script&lang=js"
export * from "./ItemTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438e996",
  null
  
)

export default component.exports